import { ApolloError, gql, useMutation } from "@apollo/client";
import {
  CrLinkServiceInput,
  CrLinkServiceMutation,
  CrLinkServiceMutationVariables,
} from "../generated/graphql";

export interface ICrLinkServiceFormProps extends CrLinkServiceInput {}

const CR_LINKSERVICE_MUTATION = gql`
  mutation crLinkService($input: CrLinkServiceInput!) {
    crLinkService(input: $input) {
      ok
      err
    }
  }
`;
export interface ICrLinkServiceInput {
  name: string;
  minAmount?: number;
  address?: string;
  operationFrom?: string;
  operationTo?: string;
  isActive?: boolean;
  useDeliveryFee?: boolean;
}
// Mutation 응답 인터페이스
export interface ICrLinkServiceMutation {
  crLinkService: {
    ok: boolean;
    err: string;
  };
}

// Mutation Variables 인터페이스
export interface ICrLinkServiceMutationVariables {
  input: ICrLinkServiceInput;
}

export const useCrLinkService = (
  onCompleted?: (data: ICrLinkServiceMutation) => void,
  onError?: (error: ApolloError) => void
) => {
  return useMutation<ICrLinkServiceMutation, ICrLinkServiceMutationVariables>(
    CR_LINKSERVICE_MUTATION,
    { onCompleted, onError }
  );
};
